module.exports = __webpack_public_path__ + "img/pt.67bf8f9e.png";